import { useQuery } from '@apollo/client'

import { GET_STORE, GetStoreQuery, GetStoreQueryVariables } from '@/graphql'

import { StoreAddress } from './StoreAddress'

type Props = {
  id: string
}

export const StoreAddressWithQuery: React.FC<Props> = props => {
  const { id } = props
  const { data } = useQuery<GetStoreQuery, GetStoreQueryVariables>(GET_STORE, {
    variables: { id },
  })
  return data?.store.location ? (
    <StoreAddress {...data?.store.location} />
  ) : null
}
